import * as types from './mutation-types';

export const ActionSetBreadcrumb = ({ commit }, payload) => {
    commit(types.SET_BREADCRUMB, payload)
}